<nz-modal (nzOnCancel)="closePreview()" [nzFooter]="null" [nzNoAnimation]="true"
          [nzVisible]="service.visible()" [nzWidth]="1280" nzMaskClosable="true" nzTitle="PDF Form">
  <ng-container *nzModalContent>
    @if (service.blobUrl()) {
      <object [attr.data]="service.blobUrl()" style="width: 100%; height: 70vh"
              type="application/pdf">
        <p>Insert your error message here, if the PDF cannot be displayed.</p>
      </object>
    } @else {
      <div style="width:100%; height: 60vh;">
        <nz-skeleton [nzActive]="true"></nz-skeleton>
      </div>
    }
  </ng-container>
</nz-modal>
